import React from 'react';
import ReactDOM from 'react-dom/client';
import Questionnaire from './Questionnaire';

const $container = document.getElementById('blanket-quiz-app');
const root = ReactDOM.createRoot($container);

root.render(<Questionnaire />);
